import React from "react"
import loadable from '@loadable/component'
import NewLoader from "../NewLoader/NewLoader"

const loaderOptions = { fallback: <NewLoader overLay={false} /> }

const UrlExtractorTool = loadable(() => import("./UrlExtraction/UrlExtractorTool"), loaderOptions)
const UrlStatusChecker = loadable(() => import("./UrlStatusChecker/UrlStatusChecker"), loaderOptions)
const MetaChecker = loadable(() => import("./MetaChecker/MetaChecker"), loaderOptions)
const IndexabilityChecker = loadable(() => import("./IndexabilityChecker/IndexabilityChecker"), loaderOptions)
const ContrastChecker = loadable(() => import("./ContrastChecker/ContrastChecker"), loaderOptions)
const FontReadabilityChecker = loadable(() => import("./FontReadabilityChecker/FontReadabilityChecker"), loaderOptions)
const HttpHeaderChecker = loadable(() => import("./HttpHeaderChecker/HttpHeaderChecker"), loaderOptions)
const MarketingRoiCalculator = loadable(() => import("./MarketingRoiCalculator/MarketingRoiCalculator"), loaderOptions)
const HeadingHierarchyChecker = loadable(() => import("./HeadingHierarchyChecker/HeadingHierarchyChecker"), loaderOptions)
const SchemaChecker = loadable(() => import("./SchemaChecker/SchemaChecker"), loaderOptions)
const ContentCapacityTool = loadable(() => import("./ContentCapacityTool/ContentCapacityTool"), loaderOptions)

type InteractiveToolSectionProps = {
    featureType?: string
    [key: string]: any
    pageSlug?:string
}

const InteractiveToolSection: React.FC<InteractiveToolSectionProps> = ({ featureType, pageSlug, toolConfig, ...props}) => {
    let parsedConfig = {};
    try {
        if (toolConfig) {
            if (typeof toolConfig === 'string') {
                parsedConfig = JSON.parse(toolConfig);
            } else if (toolConfig.internal && toolConfig.internal.content) {
                parsedConfig = JSON.parse(toolConfig.internal.content);
            } else {
                parsedConfig = toolConfig;
            }
        }
    } catch (e) {
        console.error("Failed to parse toolConfig JSON", e);
    }

    const extendedProps = { ...props, toolConfig: parsedConfig };

    switch (featureType) {
        case "URLExtraction":
            return <UrlExtractorTool { ...extendedProps } pageSlug={pageSlug} />

        case "HttpStatusChecker":
            return <UrlStatusChecker { ...extendedProps } pageSlug={pageSlug}/>

        case "MetaChecker":
            return <MetaChecker { ...extendedProps } pageSlug={pageSlug}/>

        case "indexabilityChecker":
            return <IndexabilityChecker { ...extendedProps } pageSlug={pageSlug}/>
            
        case "contrastChecker":
            return <ContrastChecker { ...extendedProps }/>
        
        case "fontChecker":
            return <FontReadabilityChecker { ...extendedProps } />

        case "httpHeaderChecker":
            return <HttpHeaderChecker { ...extendedProps } />
        
        case "roiCalculator":
            return <MarketingRoiCalculator {...extendedProps} />
            
        case "headingHierarchyChecker":
            return <HeadingHierarchyChecker {...extendedProps} pageSlug={pageSlug} />

        case "schemaChecker":
            return <SchemaChecker {...extendedProps} pageSlug={pageSlug} />

        case "contentCapacityTool":
            return <ContentCapacityTool {...extendedProps} pageSlug={pageSlug} />
            
        default:
            return null;

    }
}

export default InteractiveToolSection
